import AbstractFormField, {AbstractFormFieldProperties} from "./AbstractFormField";
import {CSSProperties, ReactNode} from "react";
import {BorderStyle, Field} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import {PortalAnnotation} from "../../../../shared/models/PortalAnnotation";
import FunctionHelper from "../../../../shared/helper/FunctionHelper";
import {Dropdown, DropdownProps} from "primereact/dropdown";
import {SelectItemOptionsType} from "primereact/selectitem";

interface ComboboxFieldProperties extends AbstractFormFieldProperties, DropdownProps {
	onValue: (value: string) => void;
}

export class ComboboxField extends AbstractFormField<ComboboxFieldProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let field: Field = Field.fromJson(this.props.field.get());

		let options: SelectItemOptionsType = [];
		for (let value of FunctionHelper.applyValue(field.value, Field.getValueDefault())) {
			options.push({
				label: value.display,
				value: value._export
			})
		}

		let fieldElements: Array<ReactNode> = [];
		for (let annotation of FunctionHelper.applyValue(field.annotation, Field.getAnnotationDefault())) {
			if (!this.shouldRenderAnnotation(annotation)) {
				continue;
			}

			let portalAnnotation: PortalAnnotation = PortalAnnotation.fromJson(
				FunctionHelper.applyValue(annotation, Field.getAnnotationDefault())
			);

			let fieldStyle: CSSProperties = {
				...this.computeFieldsStyle(portalAnnotation),
				...this.props.style
			};

			if (FunctionHelper.exists(portalAnnotation.border)) {
				fieldStyle.borderColor = portalAnnotation.border!.interiorColor;
				fieldStyle.borderWidth = portalAnnotation.border!.width!.toString();

				if (portalAnnotation.border!.style === BorderStyle.Dashed) {
					fieldStyle.borderStyle = "dashed";
				}
			}

			fieldElements.push(
				<Dropdown className={"field " + field.subType!.toLowerCase() + "-field"} style={fieldStyle}
						  key={field.objectKey + " " + portalAnnotation.objectKey} options={options}
						  value={this.props.value} disabled={this.props.disabled}
						  tabIndex={this.getTabIndex(annotation.objectKey)}
						  onChange={(event) => {
							  this.props.onValue(event.target.value);
						  }}/>
			);
		}

		return fieldElements;
	}
}